import { render, staticRenderFns } from "./RoteirizacaoMotoristasParams.vue?vue&type=template&id=760ecd52&"
import script from "./RoteirizacaoMotoristasParams.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoMotoristasParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports